import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  _showLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showLoading: Observable<boolean> = this._showLoading.asObservable();

  setLoading(state:boolean) {
    this._showLoading.next(state);
  }
}
